import React, { Component } from 'react';
import { Icon, Row, Col } from 'antd';
import { ViewField } from '../../../common/view_field/view_field';
import RevivalChart  from './revivalChart';
import moment from 'moment-timezone';
import './overview.css';

const OverviewColumn = ({span=8, children}) => (
  <Col xs={{span: 24}} sm={{span: span}} className="overview-page__item">
    { children }
  </Col>
);

class Overview extends Component {
  render() {
    const { name, code, notes, addressLine1, addressLine2, timezone, size, contactPerson,
            evangelist, revival } = this.props.church;
    return (
      <div className="m-24">
        <h2 className="dashboard-section-title">Church Profile</h2>
        <Row className="m-b-50">
          <OverviewColumn>
            <ViewField title="Name" icon={<Icon type="home"/>}><span className="bold">{name}</span></ViewField>
          </OverviewColumn>
          <OverviewColumn>
            <ViewField title="Church Code" icon={<Icon type="home"/>}><span className="bold">{code}</span></ViewField>
          </OverviewColumn>
          <OverviewColumn>
            <ViewField title="Church Size" icon={<Icon type="team"/>}><span className="bold">{size}</span></ViewField>
          </OverviewColumn>
        </Row>
        <Row className="m-b-50">
          <OverviewColumn>
            <ViewField title="Address (Main Campus)" icon={<Icon type="environment-o" />}>
              {addressLine1}<br />{addressLine2}
            </ViewField>
          </OverviewColumn>
          <OverviewColumn>
            <ViewField title="Contact Person" icon={<Icon type="user"/>}>{contactPerson}</ViewField>
          </OverviewColumn>
          <OverviewColumn>
            <ViewField title="Evangelist" icon={<Icon type="user"/>}>
              <div className="bold">{evangelist.name}</div>
              <div>{evangelist.phone}</div>
              <div><a href={`mailto:${evangelist.email}`}>{evangelist.email}</a></div>
            </ViewField>
          </OverviewColumn>
        </Row>
        <Row className="m-b-50">
          <OverviewColumn span={24}>
            <ViewField title="Notes">{notes}</ViewField>
          </OverviewColumn>
        </Row>
        { revival.phase < 3 &&
          <span>
            <h2 className="dashboard-section-title">Event Schedule</h2>
            <Row className="overview-page__church-revival-chart m-b-50">
              <RevivalChart {...this.props}/>
            </Row>
            <Row className="m-b-50">
              <OverviewColumn>
                <ViewField title="Event Preparation Start" icon={<Icon type="calendar"/>}>
                  <span className="bold">{moment.unix(revival.preparationStartDate).tz(timezone).format('LL')}</span>
                </ViewField>
              </OverviewColumn>
              <OverviewColumn>
                <ViewField title="Event Start" icon={<Icon type="calendar"/>}>
                  <span className="bold">{moment.unix(revival.startDate).tz(timezone).format('LL')}</span>
                </ViewField>
              </OverviewColumn>
              <OverviewColumn>
                <ViewField title="Event Finish" icon={<Icon type="calendar"/>}>
                  <span className="bold">{moment.unix(revival.endDate).tz(timezone).format('LL')}</span>
                </ViewField>
              </OverviewColumn>
            </Row>
          </span>
        }
      </div>
    );
  }
}

export default Overview;



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/overview/overview.js